import { pipe } from 'fp-ts/function';
import {
    DateTimeUtils,
    useDateTimeLocalizationInfo,
    useLocalizeEnum,
    useLocalizeText,
    useTimezone,
} from '@mews/framework';
import { ServiceOrderState } from '@mews-commander/data-access';
import { SpacedDash, SpacedMiddleDot } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { compactArray } from '@mews/fp';
import { EnrichedReservation } from './types';

const RESERVATION_STATE_TEXT_KEY: Partial<Record<ServiceOrderState, TextKey>> = {
    [ServiceOrderState.Started]: TextKey.CheckedIn,
    [ServiceOrderState.Processed]: TextKey.CheckedOut,
};

export const ReservationSearchDropdownItemDescription = ({ reservation }: { reservation: EnrichedReservation }) => {
    const localizeEnum = useLocalizeEnum();
    const localizeText = useLocalizeText();
    const timezone = useTimezone();
    const dateTimeLocalizationInfo = useDateTimeLocalizationInfo();

    const reservationStateTextKey = RESERVATION_STATE_TEXT_KEY[reservation.serviceOrderState];
    const reservationState = reservationStateTextKey
        ? localizeText({ textKey: reservationStateTextKey })
        : localizeEnum('ServiceOrderState', reservation.serviceOrderState);

    const startDateString = DateTimeUtils.dateTimeUtcStringToDateString(
        reservation.startUtc,
        dateTimeLocalizationInfo,
        timezone
    );

    const endDateString = DateTimeUtils.dateTimeUtcStringToDateString(
        reservation.endUtc,
        dateTimeLocalizationInfo,
        timezone
    );

    return (
        <>
            {pipe(
                [`${startDateString}${SpacedDash}${endDateString}`, reservation.resourceName, reservationState],
                compactArray,
                (arr) => arr.join(SpacedMiddleDot)
            )}
        </>
    );
};
